"use client";

import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";

type CartUi = {
  open: boolean;
  openCart: () => void;
  closeCart: () => void;
};

const Ctx = createContext<CartUi | null>(null);

export function CartUiProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const openCart = useCallback(() => setOpen(true), []);
  const closeCart = useCallback(() => setOpen(false), []);
  const value = useMemo(() => ({ open, openCart, closeCart }), [open, openCart, closeCart]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useCartUi(): CartUi {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useCartUi must be used within CartUiProvider");
  return ctx;
}
